import { ApplicationSettings } from '../../models/settings';
import BaseComponentModel from './base-component-model';
import IButton from '../../models/button/IButton';
import { Entry } from 'contentful';
import IShouldReturnEntity from '../../api-clients/IShouldReturnEntity';
import { ExcludedEntitiesHelper } from '../../api-clients/page-template-clients/helpers/excluded-entities-helper';

export default class CtaComponentModel extends BaseComponentModel {
  ctaID?: string;
  textColor?: string;
  wrapperBorderColor?: string;
  wrapperBackgroundColor?: string;
  url?: string;
  text: any;
  buttons?: IButton[];
  appSettings: ApplicationSettings;

  protected shouldReturnEntity(entry: Entry<any>): IShouldReturnEntity {
    const requiredFields = ['text'];
    const notEmptyFields = [];

    return this.excludedEntitiesHelper.shouldComponentBeReturned(
      this.component,
      entry,
      requiredFields,
      notEmptyFields,
    );
  }

  public excludedEntitiesHelper = new ExcludedEntitiesHelper();
  public component = 'CtaButton';

  constructor(data: any, appSettings: ApplicationSettings) {
    super('cta', appSettings);

    const ctaShouldReturn = this.shouldReturnEntity(data);

    if (!ctaShouldReturn.shouldReturn) {
      this.exclusionReasons.push(...ctaShouldReturn.shouldNotReturnReasons);
      this.isValid = false;
      return;
    }

    this.ctaID = data.id;
    this.textColor = data.copyColor ?? appSettings.branding?.primaryColor;
    this.wrapperBackgroundColor = data.wrapperBackgroundColor;
    this.wrapperBorderColor = data.wrapperBorderColor ?? appSettings.branding?.primaryColor;
    this.url = data.url;
    this.text = { json: data.text?.fields?.richText };
    this.buttons = data?.buttons?.map((button) => {
      return new IButton(button, appSettings.branding);
    });
    this.appSettings = appSettings;
  }
}
